{
  "name": "dla-writer",
  "displayName": "OctiPad collab writer",
  "description": "OctiPad collab writer",
  "version": "3.0.5",
  "private": true,
  "type": "module",
  "scripts": {
    "build": "adornis-build project build --deployPath /app/dist --listenPort 3000 --nodePort 7000",
    "start": "adornis-build project start --no-production --inspect-port 9222",
    "test": "echo no tests defined; exit 0"
  },
  "dependencies": {
    "@adornis/ass": "^10.1.13",
    "@adornis/base": "^11.5.9",
    "@adornis/baseql": "13.10.1",
    "@adornis/chemistry": "^12.16.4",
    "@adornis/collab": "^1.2.31",
    "@adornis/config": "^10.4.4",
    "@adornis/data-view": "^17.7.5",
    "@adornis/dialog": "^12.2.6",
    "@adornis/docs": "^0.2.47",
    "@adornis/filter": "^1.3.20",
    "@adornis/fonts": "^12.0.97",
    "@adornis/forms": "14.3.17",
    "@adornis/popover": "^14.0.70",
    "@adornis/router": "^2.4.13",
    "@adornis/ssr": "^12.0.11",
    "@adornis/tiptap": "^2.17.16",
    "@adornis/translation": "^4.0.64",
    "@adornis/translation-core": "^4.0.36",
    "@adornis/user-forms": "^14.2.12",
    "@adornis/users": "^14.0.51",
    "@tiptap/extension-gapcursor": "^2.8.0",
    "@tiptap/extension-highlight": "^2.8.0",
    "@types/pg": "^8.11.10",
    "lit": "^3.2.1",
    "ltijs": "^5.9.5",
    "pg": "^8.13.0",
    "rxjs": "^7.8.1",
    "y-prosemirror": "github:BigJk/y-prosemirror#master",
    "y-protocols": "^1.0.6",
    "yjs": "13.6.19"
  },
  "devDependencies": {
    "@adornis/esbuild": "^12.12.5",
    "@types/ltijs": "^4.0.11",
    "@typescript-eslint/eslint-plugin": "^8.10.0",
    "eslint": "^9",
    "eslint-config-love": "^89.0.1",
    "eslint-config-prettier": "^9.1.0",
    "typescript": "^5.6.3"
  },
  "files": [
    "dist"
  ],
  "license": "ISC",
  "@adornis/esbuild": {
    "server-path": "src/server",
    "client-path": "src/client",
    "print-path": "src/print-components",
    "standalone-path": "src/standalone-components",
    "output-path": "dist"
  },
  "packageManager": "pnpm@9.10.0+sha512.73a29afa36a0d092ece5271de5177ecbf8318d454ecd701343131b8ebc0c1a91c487da46ab77c8e596d6acf1461e3594ced4becedf8921b074fbd8653ed7051c"
}
